<script setup>
import { useRouter } from "@/components/Utils/functions";

const router = useRouter();

const props = defineProps({
  title: {
    type: String,
    default: false,
  },
});
</script>

<template>
  <v-container class="mt-8">
    <v-card outlined class="pb-10">
      <v-card-title
        class="px-md-7 tableHeader text--text justify-space-between"
      >
        <span>{{ title }}</span>
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class=""
              :style="{ color: 'inherit' }"
              v-on="on"
              v-bind="attrs"
              @click="router.back()"
            >
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </template>
          {{ $t("closeMsg") }}
        </v-tooltip>
      </v-card-title>
      <div class="pt-8 px-6">
        <slot />
      </div>
    </v-card>
  </v-container>
</template>
